


























































import axios from 'axios'
import { filter } from 'lodash'
import { Component, Vue } from 'vue-property-decorator'

import { numberWithCommas } from '@/helpers'

@Component({})
export default class GameList extends Vue {
  games = [
    { id: 'cross-check', name: '토박이말 가로세로 수수께끼', link: '#' },
    { id: 'initial-quiz', name: '토박이말 첫소리로 맞히기', link: '#' },
    { id: 'find-game', name: '토박이말 찾기 놀이', link: '/sub04_3' },
  ]

  rankings = []

  async created() {
    this.rankings = await axios
      .get('/game/ranking.php')
      .then(data => data.data.data)
      .catch(e => console.error(e))
  }

  onChangeGameMode(game: Game) {
    this.$emit('onChangeGameMode', game)
  }

  withComma(value: number) {
    return numberWithCommas(value)
  }

  getRankingsOf(type: string) {
    return filter(this.rankings, (o: Ranking) => o.type === type)
  }
}
